export const paiseToRupees = (paise: number | null | undefined) =>
  Math.round(Number(paise ?? 0)) / 100;

/** Read available balance from payouts-service balance/account payloads. */
export const availableBalancePaiseFromWire = (payload: unknown): number => {
  if (!payload || typeof payload !== "object") return 0;
  const record = payload as Record<string, unknown>;
  const keys = [
    "ledger_available_balance_paise",
    "ledgerAvailableBalancePaise",
    "bank_reported_balance_paise",
    "bankReportedBalancePaise",
    "available_balance_paise",
    "availableBalancePaise",
    "available_balance",
    "availableBalance",
  ];
  for (const key of keys) {
    const value = record[key];
    if (typeof value === "number" && Number.isFinite(value)) return value;
    if (typeof value === "string" && value.trim() && !Number.isNaN(Number(value))) {
      return Number(value);
    }
  }
  return 0;
};

export const availableBalanceRupeesFromWire = (payload: unknown) =>
  paiseToRupees(availableBalancePaiseFromWire(payload));

export const rupeesToPaise = (rupees: number | string | null | undefined) =>
  Math.round(Number(String(rupees ?? 0).replace(/,/g, "")) * 100);

export const formatPayoutRupees = (
  amount: number | null | undefined,
  options: { decimals?: boolean; compact?: boolean } = {},
) => {
  const value = Number(amount ?? 0);

  if (options.compact) {
    if (Math.abs(value) >= 10000000) return `${(value / 10000000).toFixed(2)} Cr`;
    if (Math.abs(value) >= 100000) return `${(value / 100000).toFixed(2)} L`;
  }

  return `\u20B9${value.toLocaleString("en-IN", {
    minimumFractionDigits: options.decimals ? 2 : 0,
    maximumFractionDigits: options.decimals ? 2 : 0,
  })}`;
};
